<template>
  <div class="ListClientes">
    <HeaderPage>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox v-on:filterExport="exportDados" />
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import FilterBox from "@/app/domains/Report/components/Customer/_filterBox";
import {getExportClientes} from "@/app/domains/Report/services";
export default {
  name: "ListClientes",
  components: {
    HeaderPage,
    FilterBox,
  },
  data () {
    return {
      loadingPage: false,
    }
  },
  methods: {
    async exportDados (arg) {
      this.loadingPage = true
      try {
        let response = await getExportClientes(arg)

        if (response.error == false) {
          this.$message({
            showClose: true,
            message: "Relatorio gerado com sucesso!",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.data,
            type: "warning",
          });
        }
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
  }
}
</script>

<style scoped>

</style>
